export default "__VITE_ASSET__B2M9H9tF__"